import { useState, useMemo, useRef } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { ModalRef } from "@shared/components";
import { Code } from "@modules/codes/types";
import { useFetchResourcesByIdsQuery } from "@shared/services/queries";
import { ApiResponse, Discount } from "@shared/types";

export function useCodeList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const createCodeModalRef = useRef<ModalRef>(null);
  const editCodeModalRef = useRef<ModalRef>(null);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<Code>({
    resource: "v1/limited_code_admin",
    filters: getQueryParams(),
  });

  const descountIds = useMemo(
    () => [...new Set(rows?.map((code) => code.discount).filter((id): id is number => !!id))],
    [rows]
  );

  const { data: discounts } = useFetchResourcesByIdsQuery<ApiResponse<Discount>>({
    resource: "v1/discount_admin",
    ids: descountIds,
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,

    createCodeModalRef,
    editCodeModalRef,
    discounts: discounts?.results,
    refetch,
    setSelectedRows,
    translate,

  };
}
